import run from '../../utilities/run';
import $ from 'jquery';
import _ from "underscore";
import {isPresent} from "../../utilities/general";
import {combineElements} from "../../utilities/selectorHelpers";
import addressValidationFactory from '../common/AddressValidation.js';
import AsnStore from '../../stores/AsnStore';
import AbilityStore from '../../stores/AbilityStore';
import AddressEventBus from '../common/AddressEventBus';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import {instantiateSelect2} from "../../utilities/select2able";

export default function NewFacility(){
  const self = this;
  const els = {};
  const portletNamespace = $("#asn-portlet-namespace").data("namespace").trim();
  const facilityEl = $('#add-facility-form');
  const addressEl = $('#edit-address-verification');
  const conId = facilityEl.attr("data-conId");
  const hc = facilityEl.attr("data-hc");
  const countryFacList = JSON.parse(facilityEl.attr("data-countryList"));
  const validationReqdCountries = JSON.parse(facilityEl.attr("data-validation-reqd-countries")); 
  const retState = '' + facilityEl.attr("data-ret-state");
  const selectedPhoneCode = facilityEl.attr("data-selected-phone-code");
  const getPhoneCodesURL = facilityEl.attr("data-phone-codes-url");
  const countriesPhoneCodeList = JSON.parse(facilityEl.attr("data-countries-phonecode-list"));
  const addressValidationUrl = facilityEl.attr("data-validate-address-url");
  const addFacilityUrl = facilityEl.attr("data-add-facility-url");
  const createAsnUrl = facilityEl.attr("data-create-asn-url");
  const organizations = facilityEl.data("organizations");
  const savedLocationsSelect =  $("#"+portletNamespace+"cmrAddresses");
  const facNameCheckUrl = facilityEl.attr("data-fac-name-check-url")
  const facIdCheckUrl = facilityEl.attr("data-fac-id-check-url");
  const duplicateCadLocationNameMessage = facilityEl.attr("data-duplicate-location-name-message");
  const duplicateAddressIdMessage = facilityEl.attr("data-duplicate-address-id-message");
  const submitModal = new SubmitModalFlow();

  let addValResponse = {};

	const elementsMap = {
		facilityModal : '#asn-wizard-add-facility-Modal',
		submitThisAddressBtn : '#submit-edit-returned-address',
		addFacilityCountrySelect : '#countryOrigin',
		facilityAddress1 : '#rad-address-1',
		facilityAddress2 : '#rad-address-2',
		facilityCity : '#rad-city',
		facilityZipCode : '#rad-zip-code',
		addFacilityCancelBtn : '#facility-cancel-btn',
		facilityContactName : '#rma-first-name',
		facilityPhoneCode : '#rad-country-code',
		facilityPhone : '#rad-phone',
		facilityEmail : '#rad-email-address',
		facilityName : '#rad-facility-name',
		facilityId : '#rad-return-address-id',
		facilityStateDropDown : '#edit-retailer-basic-state',
		facilityStateText : '#edit-retailer-basic-stateText',
		facilityStateTextWrapper : '.edit-retailer-basic-stateText-wrapper',
		facilityStateWrapper : '.edit-retailer-basic-state-wrapper',
    orgNameSelect : "#orgName",
    proximityReturnCenter : "#proximity-return-center",
    manualReturnCenter : "#manual-return",
    partnerFacility : "#partner-facility",
    redAlert : ".q-alert-red",
    stateLabel:'#state-label',
    postalCodeLabel : ".asn-dest-facility-postal-code_required"
	}

	const addressElementsMap = {
		addressEntered : '#div-address-enetered',
		enteredAddressRadio : '#radio-use-entered-address',
		enteredAddressText : '#edit-ret-address-entered',
		addressReturned : '#div-address-returned',
		returnedAddressRadio : '#radio-returned-address',
		returnedAddressText : '#edit-ret-address-returned',
		invalidAddress : '#div-address-returned-empty',
		invalidAddressText : '#edit-ret-address-returned-not-found',
		modifyAddressBtn : '#modify-edit-returned-address'
	}

	const domVarsEditRetAdd = {
	    form: $("#add-facility-form"),
	    validateAddress: $("#edit-ret-address-verification"),
	};

	const validationCustomMessages = {
		  errorPlacement: function(error, element) {
		    let appendClosest = $(element).data('error-placement-append-closest');
		    if (appendClosest) {
		      $(element).closest(appendClosest).append(error);
		    } else {
		      error.insertAfter(element);
		    }
		  }
	};

	const EditRetAddressObj = {
	    init: function(){
		        domVarsEditRetAdd.form.validate(validationCustomMessages);
	    }
	};

  self.init = function(){
    //Handle focus issue on Select2 in bootstrap modal
    //https://stackoverflow.com/questions/18487056/select2-doesnt-work-when-embedded-in-a-bootstrap-modal/19574076#19574076
    $.fn.modal.Constructor.prototype.enforceFocus = function () { };
    
    EditRetAddressObj.init();
    setElements();
    setMasks();
    bindElements();
    onLoad();
  };

  function setElements(){
    setElementsFromScope(els, elementsMap, facilityEl);
    setElementsFromScope(els, addressElementsMap, addressEl);
  }

  function bindElements() {

	  els.modifyAddressBtn.click(function(e) {
	  	e.preventDefault();
	  	addressEl.modal('hide');
	    $(elementsMap.facilityModal).modal('show');
	  });

	  domVarsEditRetAdd.validateAddress.click(function(e){
	  	e.preventDefault();
	  	var form = facilityEl;
 	    if(form.valid() && !form.find('.dup-facName').is(':visible') && !form.find('.dup-facId').is(':visible')) {
        if(checkAsnFacilityTypes()) {
          validateAddressModal();
        } else {
          els.redAlert.show();
          window.location.hash = "facility-type-section";
        }
	    } 
	  });

	 $(elementsMap.submitThisAddressBtn).click(function(e){
	 	  e.preventDefault();
	    submitAddFacility();
	  });

	  els.addFacilityCancelBtn.click(function(e){
	    e.preventDefault();
      resetNewFacilityForm();
      $(elementsMap.facilityModal).modal('hide'); 
	  });

    els.addFacilityCountrySelect.on("change", countryChange);
    els.facilityPhoneCode.on("change", phoneCodeChange);
    els.partnerFacility.on("change",handleChangeForRedAlert);
	  facilityEl.on("blur",".facility-name",validateFacilityName);
    facilityEl.on("blur",".facility-id",validateFacilityId);
 
  }
  //duplicate facility name check
  function validateFacilityName() {
    const facName = facilityEl.find(".facility-name").val();
    $.ajax({
        async: false,
        data: {
          [`${portletNamespace}facName`]:facName
        },
        url: facNameCheckUrl,
        dataType:"JSON",
        type: 'POST',
        success: function(data){
          if(data.response== true) {
            facilityEl.find('.dup-facName').show();  
          }else{
            facilityEl.find('.dup-facName').hide();
          }  
        }  
     });
  }

  function validateFacilityId() {
    const facId =   facilityEl.find(".facility-id").val();
    $.ajax({
        async: false,
        data: {
          [`${portletNamespace}facId`]:facId
        },
        url: facIdCheckUrl,
        dataType:"JSON",
        type: 'POST',
        success: function(data){
          if(data.response== true) {
            facilityEl.find('.dup-facId').show();
          }else{
            facilityEl.find('.dup-facId').hide();
          }  
        }  
     });

  }

  function setMasks() {
    $('.phone-number').attr("placeholder", "(___) ___-____");
		$('.phone-number').inputmask({
		  mask: "(999) 999-9999"
		});
  }
  
  function setUnMasks() {
    $('.phone-number').attr("placeholder", "");
    $('.phone-number').inputmask({
		  mask: ""
    }); 
  }

  function onLoad() {
    els.redAlert.hide();
    $(organizations).each(function(){
      var option = $('<option />');
      option.attr('value', this.orgId).text(this.orgName);
      els.orgNameSelect.append(option);
    });

    els.partnerFacility.prop('checked', true);

	  $(countryFacList).each(function(){
	    var option = $('<option />');
	    option.attr('value', this.conId).text(this.conName);
	    els.addFacilityCountrySelect.append(option);
	  });

    $(countriesPhoneCodeList).each(function(){
	    var option = $('<option />');
      if(this.conPhoneCode === '+1'){
				if(els.facilityPhoneCode.find('option[value="'+this.conPhoneCode+'"]').length == 0){
					option.attr('value', this.conPhoneCode).text("United States of America/Canada +1");
				}
			}else{
				option.attr('value', this.conPhoneCode).text(this.conPhoneText);
			}
	    els.facilityPhoneCode.append(option);
	  });

	  els.addFacilityCountrySelect.find('option[value='+conId+']').prop('selected', 'selected').trigger('change');
	  print_state('edit-retailer-basic-state',conId);
	  if (retState != null && retState != '' && (conId== "1" || conId == "2")) {
	  	  els.facilityStateTextWrapper.hide();
	      els.facilityStateDropDown.attr('name', 'cadState');
	  		els.facilityStateDropDown.find('option[value='+retState+']').prop('selected', 'selected').trigger('change');
	      els.facilityStateDropDown.addClass("required");
	  }else if ((retState == null || retState == '') && (conId== "1" || conId == "2")) {
	  	  els.facilityStateTextWrapper.hide();
	      els.facilityStateDropDown.attr('name', 'cadState');
	      els.facilityStateDropDown.addClass("required");
	  }else if (conId != "1" || conId != "2") {
        els.facilityStateTextWrapper.show();
	      els.facilityStateWrapper.hide();
	      els.facilityStateText.val(retState);
	      els.facilityStateDropDown.attr('name', 'notrequiredradState');
	      els.facilityStateText.attr('name', 'cadState');
	      els.facilityStateDropDown.removeClass("required");
	      els.facilityStateText.addClass("required");
	      /*$(".edit-retailer-basic-stateText").val(retState);*/
		}

		instantiateSelect2(facilityEl.find('.select2-select'));
    
    let countryVal = els.addFacilityCountrySelect.find('option:selected').val();
	  let isValidCountry = false;
      let countryValue='';
      $(countryFacList).each(function() {
        if(this.conId.toString() === countryVal.toString()) {
          countryValue = this.conCode;
          return false;
        } 
      });
      $(validationReqdCountries).each(function() {
        if(this.cdmValue.toString() === countryValue.toString()) {
          isValidCountry = true;
          return false;
        } 
      });
      if(isValidCountry){
        $(".country_not_supported").hide();        
      }else{
        $(".country_not_supported").show();
      }


  }

  function validateAddressModal() {
  	  $(elementsMap.facilityModal).modal('hide');
      var form = facilityEl;
			var state = '';
			let countryVal = els.addFacilityCountrySelect.find('option:selected').val();
      if(els.addFacilityCountrySelect.val() == '1' || els.addFacilityCountrySelect.val() == '2') {
      	state = els.facilityStateDropDown.val();
      } else {
      	state = els.facilityStateText.val();
      }
      let isValidCountry = false;
      let countryValue='';
      $(countryFacList).each(function() {
        if(this.conId.toString() === countryVal.toString()) {
          countryValue = this.conCode;
          return false;
        } 
      });
      $(validationReqdCountries).each(function() {
        if(this.cdmValue.toString() === countryValue.toString()) {
          isValidCountry = true;
          return false;
        } 
    });
      // Call if address details has been changed
      if(form.valid()) {
				if(isValidCountry){
					$.ajax({
						url: addressValidationUrl,
						type: "POST",
						data: {
									[`${portletNamespace}cadAddress1`]: els.facilityAddress1.val(),
									[`${portletNamespace}cadAddress2`]: els.facilityAddress2.val(),
									[`${portletNamespace}cadCity`]: 	els.facilityCity.val(),
									[`${portletNamespace}cadState`]: 	state,
									[`${portletNamespace}cadZipcode`]: 	els.facilityZipCode.val(),
									[`${portletNamespace}cadCountry`]: 	countryValue
							},
						beforeSend: function () {
								$.blockUI({message: 'Validating Address, Please Wait..'});
						},
						complete: function () {
								$.unblockUI();
						},
						success: function (data, textStatus, jqXHR) {
								addValResponse = $.parseJSON(data);
								if (addValResponse.result == true) {
										EditChecker.setPageClean();
										els.addressReturned.css("display", "");
										els.invalidAddress.css("display", "none");
										els.invalidAddressText.css("display", "none");
										els.returnedAddressRadio.prop('checked', true);
										els.enteredAddressRadio.prop('checked', false);
										els.returnedAddressRadio.show();
										checkSubmitAddressForm(addValResponse);
								} else {
										els.addressReturned.css("display", "none");
										els.invalidAddress.css("display", "");
										els.invalidAddressText.css("display", "");
										els.invalidAddressText.html('Unable to find a validated address');
										els.returnedAddressRadio.hide();
										els.returnedAddressRadio.prop('checked', true);
										els.enteredAddressRadio.prop('checked', false);
										checkSubmitAddressForm(addValResponse);
								}
						}
				  });
				}else{
					submitAddFacility(false);
				}
      }
  }

  function checkSubmitAddressForm(addValResponse){
      els.enteredAddressText.html(addValResponse.enteredAdd);
      els.returnedAddressText.html(addValResponse.returnedAdd);
      addressEl.modal('show');
  }

  function phoneCodeChange(){
    let phonecode= els.facilityPhoneCode.val().toString();
    if( phonecode === '+1'){
      setMasks();
    }else{
      setUnMasks();
      $('.phone-number').val('');
    }
  }

  function countryChange() {
    let countryVal = els.addFacilityCountrySelect.find('option:selected').val();
    if(countryVal != null && countryVal != '' && countryVal != '0') {
      $.ajax({
          url: getPhoneCodesURL,
          type: "POST",
          //dataType: "json",
          data: {[`${portletNamespace}countryVal`] :countryVal},
          success: function (data) {
            var jsonData = JSON.parse(data);
              if(jsonData.response == "success") {
                  var phoneCodesList = jsonData.phoneCodes;
                  $(phoneCodesList).each(function(){
                    if(this.conPhoneCode === '+1'){
											els.facilityPhoneCode.find('option[value="'+this.conPhoneCode+'"]').prop('selected', 'selected').trigger('change');
										}else{
                      els.facilityPhoneCode.find('option:contains('+this.conPhoneText+')').prop('selected', 'selected').trigger('change');
										}
                    return;
                  });
              }
          }
       });
      }

      let isValidCountry = false;
      let countryValue='';
      $(countryFacList).each(function() {
        if(this.conId.toString() === countryVal.toString()) {
          countryValue = this.conCode;
          return false;
        } 
      });


      let checkZipCode = false;
      $(countryFacList).each(function() {
        if(this.conId.toString() === countryVal.toString()) {
            if(this.conPostalCodeRequired==='Y'){
              checkZipCode=true;
            }
        }
      });

      if(checkZipCode){
        els.facilityZipCode.prop('required',true);        
        els.postalCodeLabel.text('Postal Code *');
        els.facilityZipCode.addClass("required");
      }else{
        els.facilityZipCode.removeClass("zipcodeUS");
        els.facilityZipCode.removeClass("required");
        els.facilityZipCode.prop('required',false);
        els.postalCodeLabel.text('Postal Code');
      }
      $(validationReqdCountries).each(function() {
        if(this.cdmValue.toString() === countryValue.toString()) {
          isValidCountry = true;
          return false;
        } 
      });
      if(isValidCountry){
        $(".country_not_supported").hide();        
      }else{
        $(".country_not_supported").show();
      }

      if (countryVal == "1" || countryVal == "2") {
          setMasks();
          els.stateLabel.text('State/Province/Region *');
          els.facilityStateTextWrapper.hide();
          els.facilityStateText.attr('name', 'notrequiredradState');
          els.facilityStateText.val("");
          els.facilityStateWrapper.show();
          els.facilityStateDropDown.attr('name', 'cadState');
          print_state('edit-retailer-basic-state', this.selectedIndex);
          if (countryVal == "1") {
              els.facilityZipCode.addClass("zipcodeUS");
          } else {
          	els.facilityZipCode.removeClass("zipcodeUS");
          }
      } else {
          setUnMasks();
          $('.phone-number').val('');
          els.stateLabel.text('State/Province/Region');
          els.facilityStateTextWrapper.show();
          els.facilityStateText.attr('name', 'cadState');
          els.facilityStateWrapper.hide();
          els.facilityStateDropDown.attr('name', 'notrequiredradState');
          els.facilityStateDropDown.val("");
          els.facilityZipCode.removeClass("zipcodeUS");
      }
  };

  function submitAddFacility(validationReqdCountries=true) {
    addressEl.modal('hide');
    let state = '';
    let index = 0;

    if(els.addFacilityCountrySelect.val() == '1' || els.addFacilityCountrySelect.val() == '2') {
    	state = els.facilityStateDropDown.find('option:selected').val();
    } else {
    	state = els.facilityStateText.val();
    }

    if(els.returnedAddressRadio.is(":checked") && validationReqdCountries) {
			els.facilityAddress1.val(addValResponse.returnedAddress1);
			els.facilityAddress2.val(addValResponse.returnedAddress2);
			els.facilityCity.val(addValResponse.returnedCity);
			els.facilityZipCode.val(addValResponse.returnedZip);
    }

     let dataObj = {
          [`${portletNamespace}cadId`]: 0,
          [`${portletNamespace}cadLocationName`]: els.facilityName.val(),
          [`${portletNamespace}cadAddressId`]: els.facilityId.val(),
          [`${portletNamespace}cadAddress1`]: els.facilityAddress1.val(),
          [`${portletNamespace}cadAddress2`]: els.facilityAddress2.val(),
          [`${portletNamespace}cadCity`]:   els.facilityCity.val(),
          [`${portletNamespace}cadState`]:  state,
          [`${portletNamespace}cadZipcode`]:  els.facilityZipCode.val(),
          [`${portletNamespace}cadCountry`]:  els.addFacilityCountrySelect.val(),
          [`${portletNamespace}cadContactName`]: els.facilityContactName.val(),
          [`${portletNamespace}cadContactCountryPhoneCode`]: els.facilityPhoneCode.val(),
          [`${portletNamespace}cadContactPhone`]: els.facilityPhone.val(),
          [`${portletNamespace}cadContactEmail`]: els.facilityEmail.val(),
          [`${portletNamespace}organization.orgId`]: els.orgNameSelect.val()
    }

    if(!els.orgNameSelect.val()){
    	dataObj[`${portletNamespace}organization.orgId`] = '0';
    }

    if(els.proximityReturnCenter.prop('checked')) {
          dataObj[`${portletNamespace}cmrAddressAttributes[${index}].caaKey`] = els.proximityReturnCenter.val();
          dataObj[`${portletNamespace}cmrAddressAttributes[${index}].caaValue`]= "RC";
          index = index + 1;
    }

    if(els.manualReturnCenter.prop('checked')) {
        dataObj[`${portletNamespace}cmrAddressAttributes[${index}].caaKey`] = els.manualReturnCenter.val();
        dataObj[`${portletNamespace}cmrAddressAttributes[${index}].caaValue`] = "MR";
        index = index + 1;
    }
     
    if(els.partnerFacility.prop('checked')) {    
        dataObj[`${portletNamespace}cmrAddressAttributes[${index}].caaKey`] = els.partnerFacility.val();
        dataObj[`${portletNamespace}cmrAddressAttributes[${index}].caaValue`] = "PF";
    }

    $.ajax({
		  url: addFacilityUrl,
		  type: "POST",
		  data: dataObj,
		  beforeSend: function () {
		    		submitModal.init();
						submitModal.showLoadingModal();
		  },
		  success: function (data, textStatus, jqXHR) {
			  	  let response = $.parseJSON(data);
			      EditChecker.setPageClean();
      		  submitModal.showSuccessModal();

      		  let savedLocationsList = response.cmrAddresses;
	          //let cmrAddresses = data;
	          savedLocationsSelect.empty();
	          $(savedLocationsList).each(function() {
	            var option = $('<option />');
	            option.attr('value', this.cadId).text(this.cadLocationName);
	            savedLocationsSelect.append(option);
	          });
	          var senderAddress = savedLocationsList.filter(function(obj) { return obj.cadId==response.facilityId; })[0];
	          $('#'+portletNamespace+'cadId').val(response.facilityId);
	          savedLocationsSelect.data('options', savedLocationsList);
	          savedLocationsSelect.val(response.facilityId).trigger('change');

      		  setTimeout(function() {
				      submitModal.hideAllModals();
		        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);

            resetNewFacilityForm();
		  },
		  error: function(){
          	submitModal.showFailureModal();
      }
    });
  }

  function handleChangeForRedAlert() {
    if(checkAsnFacilityTypes()) {
      els.redAlert.hide();
    }
  }

  function checkAsnFacilityTypes() {
    let asnFacilityTypeFlag = false;
    if(els.partnerFacility.prop('checked')) {
      asnFacilityTypeFlag=true;
    }
    return asnFacilityTypeFlag;
  }

  function resetNewFacilityForm(){
    //reset input values
    facilityEl.find('input:text').val('');
    facilityEl.find('label.error').hide();
    facilityEl.find('.dup-facName').hide();
    facilityEl.find('.dup-facId').hide();
    //reset checkbox values
    els.proximityReturnCenter.prop('checked', false);
    els.manualReturnCenter.prop('checked', false);
    els.partnerFacility.prop('checked', true);
    //reset the drop down values
    els.orgNameSelect.val("").trigger('change');
    els.addFacilityCountrySelect.val("1").trigger('change');
  }
}




// WEBPACK FOOTER //
// ./src/pages/asns/Facility.js